/** Shown when Activity settings Require Knowledge is on and this item has questions. */
export default function StudentKnowledgeBanner({ show }: { show: boolean }) {
  if (!show) return null;
  return (
    <div className="student-notice student-notice--lock" role="status" style={{ marginTop: 16 }}>
      <strong>Knowledge check required</strong>
      <p>Answer the questions on this page before you can finish.</p>
    </div>
  );
}
